import createApiClient from "./api";

const api = createApiClient();

export const createWorker = async (workerData) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/workers", workerData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchWorkers = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/workers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { project_id: projectId },
  });
  return response.data;
};

export const fetchWorker = async (workerId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/workers/${workerId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateWorker = async (workerId, workerData) => {
  const token = localStorage.getItem("token");
  const response = await api.put(`/workers/${workerId}`, workerData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteWorker = async (workerId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/workers/${workerId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
